import { getGetShellQueryOptions } from '@pa/api/clinic'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { clinicFor } from '@/features/home'
import { ClinicShell } from '@/features/shell'

/**
 * Every page of one clinic: guard row 5 (Frontend §5.3: only an active membership's clinic, or the impersonated
 * one; anything else → `/`), then the C-00 shell (task 04).
 */
export const Route = createFileRoute('/_authed/clinics/$clinicId')({
  beforeLoad: async ({ context, params }) => {
    const clinic = clinicFor(context.me, params.clinicId)
    if (!clinic) redirect({ to: '/', replace: true, throw: true })
    const membership = context.me.memberships.find((m) => m.clinic.id === params.clinicId)
    if (membership) return { clinic, role: membership.role, timeZone: membership.clinic.timeZone }
    // An impersonating super admin acts as Clinic Admin (D-09); the clinic's time zone comes from #14.
    const shell = await context.queryClient.query({ ...getGetShellQueryOptions(params.clinicId), staleTime: 30_000 })
    return { clinic, role: 'admin' as const, timeZone: shell.clinic.timeZone }
  },
  component: function ClinicLayout() {
    const { clinicId } = Route.useParams()
    const { role, env } = Route.useRouteContext()
    return <ClinicShell clinicId={clinicId} role={role} adminOrigin={env.VITE_ADMIN_APP_ORIGIN} />
  },
})
